/**
 * Which boxplot dataset reflects the current / primary period (matches build order in dashboards).
 * @param {boolean} hasComparison1
 * @param {boolean} hasComparison2
 * @param {number} datasetCount
 * @returns {number}
 */
export function getBoxplotPrimaryDatasetIndex(hasComparison1, hasComparison2, datasetCount) {
  const n = datasetCount || 0;
  if (n <= 1) return 0;
  if (hasComparison1 && !hasComparison2) return 1;
  return 0;
}

/**
 * Qualitative spread label key suffix: low / medium / high (Likert SD bands).
 * @param {number|null|undefined} sd
 * @returns {'low'|'medium'|'high'}
 */
export function spreadKeyFromSd(sd) {
  if (sd == null || Number.isNaN(Number(sd))) return 'medium';
  const s = Number(sd);
  if (s <= 0.25) return 'low';
  if (s <= 0.50) return 'medium';
  return 'high';
}

/**
 * @param {string[]} labels - Chart x labels (dimension keys or display names)
 * @param {Array} dataPoints - Boxplot stats per category (or null)
 * @param {(label: string) => string} resolveLabel
 * @returns {Array<{ label: string, mean: number, median: number, sd: number, spreadKey: string }>}
 */
export function buildBoxplotStatsRows(labels, dataPoints, resolveLabel) {
  if (!labels?.length || !dataPoints?.length) return [];
  const rows = [];
  labels.forEach((rawLabel, i) => {
    const p = dataPoints[i];
    if (p == null || typeof p !== 'object') return;
    const mean = p.mean;
    if (mean == null || Number.isNaN(Number(mean))) return;
    const median = p.median != null && !Number.isNaN(Number(p.median)) ? Number(p.median) : Number(mean);
    const sd = p.sd != null && !Number.isNaN(Number(p.sd)) ? Number(p.sd) : 0;
    rows.push({
      label: typeof resolveLabel === 'function' ? resolveLabel(rawLabel) : String(rawLabel),
      mean: Number(mean),
      median,
      sd,
      spreadKey: spreadKeyFromSd(sd),
    });
  });
  return rows;
}
